// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .interviews-container .card-body {
  padding: 0 !important;
}
::ng-deep .interviews-container .card-header {
  margin-top: 10px !important;
}
::ng-deep .interviews-container .card {
  background-color: #ECECEC !important;
  border: none !important;
}
::ng-deep .interviews-container .btn {
  padding: 0.625rem 0.75rem;
  border-width: 1px;
  border-radius: 1px;
  font-size: 0.875rem;
  line-height: 0.75rem;
  font-weight: 400;
}
::ng-deep .interviews-container .btn [class*=icon-] {
  color: inherit;
  line-height: inherit;
}
::ng-deep .modal-dialog {
  width: 60% !important;
  max-width: 60% !important;
}

.gray {
  color: white !important;
  background-color: #585857;
}

.custom-modal .modal-dialog {
  width: 80% !important;
  max-width: 80% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/interviews/interviews-table/interviews-table.component.scss","webpack://./src/styles/global/_colors.scss"],"names":[],"mappings":"AAII;EACE,qBAAA;AAHN;AAMI;EACE,2BAAA;AAJN;AAOI;EACE,oCAAA;EACA,uBAAA;AALN;AAQI;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AANN;AAQM;EACE,cAAA;EACA,oBAAA;AANR;AAUE;EACE,qBAAA;EACA,yBAAA;AARJ;;AAYA;EACE,uBAAA;EACA,yBCnCgB;AD0BlB;;AAaE;EACE,qBAAA;EACA,yBAAA;AAVJ","sourcesContent":["@import \"../../../../styles/global/colors\";\n\n::ng-deep {\n  .interviews-container {\n    .card-body {\n      padding: 0 !important;\n    }\n\n    .card-header {\n      margin-top: 10px !important;\n    }\n\n    .card {\n      background-color: $interviews-alt-light-gray !important;\n      border: none !important;\n    }\n\n    .btn {\n      padding: 0.625rem 0.75rem;\n      border-width: 1px;\n      border-radius: 1px;\n      font-size: 0.875rem;\n      line-height: 0.75rem;\n      font-weight: 400;\n\n      [class*=\"icon-\"] {\n        color: inherit;\n        line-height: inherit;\n      }\n    }\n  }\n  .modal-dialog {\n    width: 60% !important;\n    max-width: 60% !important;\n  }\n}\n\n.gray {\n  color: white !important;\n  background-color: $interviews-gray;\n}\n\n.custom-modal {\n  .modal-dialog {\n    width: 80% !important;\n    max-width: 80% !important;\n  }\n}\n","$interviews-light-gray: #E0E0E0;\n$interviews-alt-light-gray: #ECECEC;\n$interviews-table-gray: #F5F5F5;\n$interviews-dark-gray: #262624;\n$interviews-gray: #585857;\n$interviews-blue: #085FFF;\n$interviews-scroll-blue: #b4ceff;\n$interviews-pink: #FF7FDE; \n$interviews-btn-submitted: #FADDB3;\n$interviews-btn-submitted-outline: #ED8E00;\n$interviews-btn-approved: #DAF2B7;\n$interviews-btn-approved-outline: #83D510;\n$interviews-btn-rejected: #FBCCD2;\n$interviews-btn-rejected-outline: #ED001C;\n$interviews-btn-draft: rgb(148, 148, 141);\n$interviews-btn-draft-outline: rgb(57, 57, 57);"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
